import { ITenant } from 'app/shared/model/tenant.model';
import { IUser } from 'app/shared/model/user.model';

export interface IFleet {
  id?: number;
  name?: string;
  parent?: IFleet | null;
  tenant?: ITenant | null;
  owner?: IUser | null;
}

export const defaultValue: Readonly<IFleet> = {};
